/* import specific icons */
import {
     faWarehouse,
     faClock,
     faCircleCheck,
     faCircleInfo,
     faCircleXmark,
     faDownload,
     faBell,
     faFilter
     } 
    from '@fortawesome/free-solid-svg-icons';
export const icons = {
    faWarehouse,
    faClock,
    faCircleCheck,
    faCircleInfo,
    faCircleXmark,
    faBell,
    faFilter
}

